// extracted by mini-css-extract-plugin
export default {"card":"golXW","section":"DWWt7","title":"DDMzJ"};